var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailRoundOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176152",
    "data-name": "Group 176152",
    transform: "translate(8856.5 -5767.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38381",
    "data-name": "Path 38381",
    d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
    transform: "translate(-8858.5 5765.5)",
    fill: "none",
    stroke: "#2253f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176151",
    "data-name": "Group 176151",
    transform: "translate(-9335 3039.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38249",
    "data-name": "Path 38249",
    d: "M14,3.5H2a2,2,0,0,0-2,2V13a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V5.5a2,2,0,0,0-2-2M15,13a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V5.5a1,1,0,0,1,1-1H14a1,1,0,0,1,1,1Z",
    transform: "translate(487 2735)",
    fill: "#2253f5",
    stroke: "#2253f5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38250",
    "data-name": "Path 38250",
    d: "M15.184,8.613,10,12.854,4.817,8.613a.5.5,0,1,0-.633.774l5.5,4.5a.5.5,0,0,0,.634,0l5.5-4.5a.5.5,0,0,0-.634-.774",
    transform: "translate(485 2732.5)",
    fill: "#2253f5",
    stroke: "#2253f5",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRoundOutline);
export default __webpack_public_path__ + "static/media/mail-round-outline.fd209f4888f40b44dbeaeceff18b9d61.svg";
export { ForwardRef as ReactComponent };